import React, { FC } from 'react';
import { THighlghtedOption } from '../../sitecoreJssForm/types/sitecoreJssForm.types';
import { sanitizeText } from '../../../utils/regex.utils';

const HiglightedOption: FC<THighlghtedOption> = (props): JSX.Element => {
  const { keyword, optionText } = props;
  const pattern = new RegExp(`(${sanitizeText(keyword || '')})`, 'gi');
  const parts = optionText?.split(pattern);

  return <>{keyword === '' ? optionText : parts?.map((part, i) => <>{i % 2 ? <b>{part}</b> : <>{part}</>}</>)}</>;
};

export default HiglightedOption;
